import { http } from './http'
import { getLang, getCountry } from '@/translations/i18n'
import { punctToSlash } from '@/helper'

const MINUTE = 60 * 1000
const HOUR = 60 * MINUTE

const GET_CACHE_BY_TARGET = {
  countries: {
    ttl: 24 * HOUR,
    persist: true,
    storage: 'localStorage',
  },
  'addresses.country_phone_codes': {
    ttl: 24 * HOUR,
    persist: true,
    storage: 'localStorage',
  },
  'vouchers.styles': {
    ttl: 24 * HOUR,
    persist: true,
    storage: 'localStorage',
  },
  'pages.services': {
    ttl: 10 * MINUTE,
    persist: true,
    storage: 'localStorage',
  },
  'payments.adyen_payment_config?type=dropin': {
    ttl: 100,
    persist: true,
    storage: 'localStorage',
  },
  'payments.amazon_payment_config': {
    ttl: 100,
    persist: true,
    storage: 'localStorage',
  },
  settings: {
    ttl: 10 * MINUTE,
    persist: true,
    storage: 'localStorage',
  },
}

const UNCACHED_GET_TARGETS = [
  'cart',
  'carts.mine',
  'checkout',
  'checkout.validate_addresses',
  'addresses',
  'auth.is-authenticated',
  'user',
  'user.newsletter',
]

const getRequestOptions = (target, options = {}) => {
  if (options.cache !== undefined || options.dedupe !== undefined) {
    return options
  }

  if (UNCACHED_GET_TARGETS.includes(target)) {
    return {
      ...options,
      cache: false,
    }
  }

  const cache = GET_CACHE_BY_TARGET[target]

  if (!cache) {
    return options
  }

  return {
    ...options,
    cache,
  }
}

const getLocaleParams = params => ({
  lang: getLang(),
  country_code: getCountry(),
  ...params,
})

export default {
  getItems(target, params, options = {}) {
    return http.get(punctToSlash(target), {
      ...getRequestOptions(target, options),
      params: getLocaleParams(params),
    })
  },
  getItem(target, params, options = {}) {
    return http.get(punctToSlash(target), {
      ...getRequestOptions(target, options),
      params: getLocaleParams(params),
    })
  },
  patchItem(target, params) {
    return http.patch(punctToSlash(target), {
      lang: getLang(),
      country_code: getCountry(),
      ...params,
    })
  },
  editItem(target, params) {
    return http.put(punctToSlash(target), {
      lang: getLang(),
      country_code: getCountry(),
      ...params,
    })
  },
  createItem(target, data) {
    return http.post(punctToSlash(target), data, {
      params: {
        lang: getLang(),
        country_code: getCountry(),
      },
    })
  },
  deleteItem(target, data, params) {
    return http.delete(punctToSlash(target), {
      data,
      params: {
        lang: getLang(),
        country_code: getCountry(),
        ...params,
      },
    })
  },
}
